module.exports = __webpack_public_path__ + "media/images/flags/16/Bahamas-64bdc1abbd3bd598fb5f35b601a3edf4.png";